// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"113c3289","814":"44afb12d","933":"2976193e"}[chunkId] + ".chunk.js";
};